<template>
  <div class="app__stepLabel">
    krok {{step}}.
  </div>
</template>

<script>
export default {
  props: ['step']
}
</script>